// @flow
import axios from 'lib/defaultClient';
import queryString from 'query-string';

export type WriteBrandPayload = {
  title: string,
  body: string,
  is_temp: boolean,
  tags: Array<string>,
  categories: Array<string>,
  thumbnail: ?string,
  url_slug?: ?string,
  is_private: boolean,
  series_id: ?string,
};

export const writeBrand = (payload: WriteBrandPayload) => axios.post('/brands', payload);

export type UpdateBrandPayload = {
  id: string,
  title: string,
  body: string,
  tags: Array<string>,
  categories: Array<string>,
  url_slug?: ?string,
  thumbnail?: string,
  is_temp: boolean,
  thumbnail: ?string,
  is_private: boolean,
  series_id: ?string,
};

export const updateBrand = ({ id, ...payload }: UpdateBrandPayload) =>
  axios.patch(`/brands/${id}`, payload);

export type ReadBrandPayload = {
  username: string,
  urlSlug: string,
};

export const readBrand = ({ username, urlSlug }: ReadBrandPayload) =>
  axios.get(`/brands/@${username}/${urlSlug}`);

export type UploadImagePayload = {
  file: any,
  brandId: string,
  onUploadProgress(): void,
};

export const uploadImage = ({ file, brandId, onUploadProgress }: UploadImagePayload) => {
  const data = new FormData();
  data.append('brand_id', brandId);
  data.append('image', file);
  return axios.post('/files/upload/brand', data, {
    onUploadProgress,
  });
};

export type TempSavePayload = {
  title: string,
  body: string,
  brandId: string,
};

export const tempSave = ({ brandId, title, body }: TempSavePayload) =>
  axios.post(`/brands/${brandId}/saves`, { title, body });

export type CreateUploadUrlPayload = { brandId: string, filename: string };
export const createUploadUrl = ({ brandId, filename }: CreateUploadUrlPayload) => {
  return axios.post('/files/create-url/brand-image', { brand_id: brandId, filename });
};

/* LISTING RELATED... */
export const getPublicBrands = (cursor: ?string, category: ?string, sort: ?string) => {
  return axios.get('/brands/public', {
    params: {
      cursor,
      category,
      sort,
    },
  });
};

export const getTrendingBrands = (offset: ?number) => {
  const query = offset ? `?offset=${offset}` : '';
  return axios.get(`/brands/trending${query}`);
};

export type GetUserBrandsPayload = {
  username: string,
  tag?: string,
  cursor?: string,
};

export const getUserBrands = ({ username, cursor, tag }: GetUserBrandsPayload) => {
  const query = queryString.stringify({
    cursor,
    tag,
  });
  return axios.get(`/brands/@${username}?${query}`);
};

export type GetPublicBrandsByCategoryPayload = {
  category: string,
  cursor?: string,
  sort?: string,
};

export const getPublicBrandsByCategory = (payload: GetPublicBrandsByCategoryPayload) => {
  const query = queryString.stringify(payload);
  return axios.get(`/brands/public?${query}`);
};

export type GetPublicBrandsByTagPayload = {
  tag: string,
  cursor?: string,
};

export const getPublicBrandsByTag = (payload: GetPublicBrandsByTagPayload) => {
  const query = queryString.stringify(payload);
  return axios.get(`/brands/public?${query}`);
};

export type GetTempBrandsPayload = {
  username: string,
  cursor?: string,
};

export const getTempBrands = ({ username, cursor }: GetTempBrandsPayload) => {
  const query = queryString.stringify({
    is_temp: true,
    cursor,
  });
  return axios.get(`/brands/@${username}?${query}`);
};

export const deleteBrand = (brandId: string) => {
  return axios.delete(`/brands/${brandId}`);
};

export const getBrandById = (brandId: string) => {
  return axios.get(`/brands/${brandId}`);
};

export const getBrandSequences = (brandId: string) => {
  return axios.get(`/brands/sequences?brand_id=${brandId}`);
};



// WEBPACK FOOTER //
// ./src/lib/api/brands/index.js